<template>
  <nd-dialog
    v-model="visible"
    :footer="false"
  >
    <div class="dialog-box">
      <div class="logo">
        <img src="https://static.ndmicro.com/tmd/landing/components/images/logo.png">
        <div class="close-btn" @click="closeAction">
          <img src="https://static.ndmicro.com/tmd/landing/components/images/btn_close.png">
        </div>
      </div>
      <div class="title">请下载安装“配置描述文件”进入天美贷</div>
      <div class="images">
        <img src="https://static.ndmicro.com/tmd/landing/components/images/img_01.png">
        <img src="https://static.ndmicro.com/tmd/landing/components/images/img_02.png">
      </div>
      <span class="setting">下载完成后，点击打开“<a href="App-prefs://prefs:root=Settings" data-sensors-click>设置</a>”，完成安装回到桌面找到天美贷即可使用</span>
      <nd-button
        @click="downloadWebClipProfile"
        class="download"
        data-sensors-click
      >立即下载配置描述文件
      </nd-button>
    </div>
  </nd-dialog>
</template>

<script>
export default {
  name: 'WebClipPop',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    downloadWebClipProfile () {
      window.location.href = 'https://ndmicro-ios.oss-cn-beijing.aliyuncs.com/WebClip/web_clip_tmd.mobileconfig'
    },
    closeAction () {
      this.$emit('onClose')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.dialog-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 0 40px 0;
  color: #333;
  .logo {
    width: 100%;
    padding: 0 30px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    img {
      width: 262px;
      height: 40px;
    }
    .close-btn {
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
  .title {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 45px;
    margin-top: 50px;
  }
  .images {
    display: flex;
    flex-direction: row;
    width: 100%;
    margin: 23px 0;
    padding: 0 30px;
    overflow-x: scroll;
    img {
      width: 490px;
      height: 600px;
    }
    > :last-child {
      margin-left: 20px;
    }
  }
  .setting {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666;
    line-height: 33px;
    padding: 0 85px;
    text-align: center;
    a {
      color: #FF4633;
      text-decoration: underline;
      font-size: 32px;
    }
  }
  .download {
    width: 440px;
    height: 80px;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 80px;
    margin-top: 17px;
  }
}

</style>